import { render } from "./WeekVue.vue?vue&type=template&id=66b05669&scoped=true"
import script from "./WeekVue.vue?vue&type=script&lang=js"
export * from "./WeekVue.vue?vue&type=script&lang=js"

import "./WeekVue.vue?vue&type=style&index=0&id=66b05669&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-66b05669"

export default script